import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button, Grid, Input, Table, Select, Image, Message, Container, Modal, Dimmer } from 'semantic-ui-react';
import { ITechnicianCertificatePhoto } from '../../../app/models/techniciancertificatephoto';
import TechnicianCertificateStore from '../../../app/stores/techniciancertificateStore';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../../../app/stores/rootStore';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { Link } from 'react-router-dom';
import CertificatePhotoDropzone from '../../../app/common/Dropzone/CertificatePhotoDropzone';

interface IProps {
  url: string;
}

const BarcodeView: React.FC<IProps> = ({ url }) => {
  const rootStore = useContext(RootStoreContext);
  const {closeModal, openModal} = rootStore.modalStore;
  const technicianCertificateStore = useContext(TechnicianCertificateStore);
  const {
    loadTechnicianCertificatePhoto,
    techniciancertificatephotosById,
    deleteTechnicianCertificatePhoto,
    target,
    submitting,
  } = technicianCertificateStore;

  const [active, setDimmer] = useState(false);

  return (
      <Dimmer.Dimmable
      dimmed={active}
      onMouseEnter={() => setDimmer(true)}
      onMouseLeave={() => setDimmer(false)}
    >
      <Image src={`/${url}`} />
      <Dimmer active={active}>
      <Button
                   as="a"
                  href={`/${url}`}
                  target="_Blank"
                   size='mini'
                   content="Preview"
                   color="green"

                 />
    <Button
                   as="a"
                  href={`/${url}`}
                   download
                   size='mini'
                   content="Download"
                   color="blue"

                 />
                 </Dimmer>
    </Dimmer.Dimmable>

 
  );
};

export default BarcodeView;
